const textUtils = {
  methods: {
    getLinesArrayFromString (string) {
      return string.split('\n')
    },
    getNickFromUserId (userId) {
      if (!userId) return '-'
      const user = this.$store.state.User.user_list_network.find(u => u.id === userId)
      return user ? user.nick : '-'
    },
    shortenStringWithDots (string, desiredLength) {
      if (!string || !desiredLength || desiredLength === 0) return
      if (string.length > desiredLength + 2) {
        const partsLength = desiredLength / 2
        return string.substring(0, partsLength) + '...' + string.slice(-partsLength)
      }
      return string
    },
    fullNameOfDesktopPlaylist (desktopPlaylistMedium) {
      if (!desktopPlaylistMedium) return
      if (Object.keys(desktopPlaylistMedium).length === 1) {
        desktopPlaylistMedium = this.$store.state.Medium.local_playlists_cache.find(lp => lp.id === desktopPlaylistMedium.id)
      }
      if (!desktopPlaylistMedium) return console.error('No playlist medium in cache')
      if (typeof desktopPlaylistMedium.DeviceDesktop === 'object') {
        const device = this.$store.state.Device.device_list.find(d => d.id === desktopPlaylistMedium.DeviceDesktop.Device)
        return `
        ${device ? device.name : ''}
        ${desktopPlaylistMedium.DeviceDesktop.name !== 'single' ? desktopPlaylistMedium.DeviceDesktop.name : ''}
        `
      }
      const desktop = this.$store.state.Device.desktop_list.find(d => d.id === desktopPlaylistMedium.DeviceDesktop)
      const device = this.$store.state.Device.device_list.find(d => d.id === desktop.Device)
      if (!desktop) return ''
      if (!device) return ''
      return desktop.name.length > 0 && desktop.name !== 'single' ? `${device.name}-${desktop.name}` : `${device.name}`
    },
    fullNameOfDesktopPlaylistById (desktopPlaylistId) {
      const desktop = this.$store.state.Device.desktop_list.find(d => d.LocalPlayList === desktopPlaylistId)
      if (!desktop) return 'unknown desktop'
      const device = this.$store.state.Device.device_list.find(d => d.id === desktop.Device)
      if (!device) return 'unknown device'
      return desktop.name.length > 0 && desktop.name !== 'single' ? `${device.name}-${desktop.name}` : `${device.name}`
    },
    humanFileSize (bytes, si) {
      var thresh = si ? 1000 : 1024
      if (Math.abs(bytes) < thresh) {
        return bytes + ' B'
      }
      var units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
      var u = -1
      do {
        bytes /= thresh
        ++u
      } while (Math.abs(bytes) >= thresh && u < units.length - 1)
      return bytes.toFixed(1) + ' ' + units[u]
    },
    humanDuration (milliseconds, rounded = false) {
      if (!milliseconds) return '-'
      const days = parseInt(milliseconds / 1000 / 3600 / 24)
      const millisecondsRest = milliseconds - (days * 1000 * 3600 * 24)
      const hours = this.$moment.duration(millisecondsRest).hours() ? this.$moment.duration(millisecondsRest).days() * 24 + this.$moment.duration(millisecondsRest).hours() + 'h:' : ''
      if (!rounded) {
        return days + 'd:' + hours +
        this.$moment.duration(millisecondsRest).minutes() + '\'' +
        this.$moment.duration(millisecondsRest).seconds() + '\'\'' +
        this.$moment.duration(millisecondsRest).milliseconds() + ' ms'
      } else if (rounded && days > 0) {
        return days + 'd:' + this.$moment.duration(millisecondsRest).hours() + 'h'
      } else {
        return hours +
        this.$moment.duration(millisecondsRest).minutes() + '\''
      }
    },
    humanTime (timestamp) {
      return this.$moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
    },
    msToDuration (durationMilliseconds) {
      let milliseconds = parseInt(durationMilliseconds % 1000)
      let seconds = parseInt((durationMilliseconds / 1000) % 60)
      let minutes = parseInt(durationMilliseconds / (1000 * 60))
      let hours = (minutes / 60)
      let rhours = Math.floor(hours)
      minutes = (hours - rhours) * 60
      let rminutes = Math.round(minutes)
      return this.zeroPad(rhours, 2) + ':' + this.zeroPad(rminutes, 2) + ':' + this.zeroPad(seconds, 2) + '.' + this.zeroPad(milliseconds, 3)
    },
    zeroPad (num, places) {
      return String(num).padStart(places, '0')
    },
    formatLocalPlaylistContent (payload) {
      // payload may be id, or medium (in devicegroup row expanded)
      let playlist
      if (!isNaN(payload)) {
        playlist = this.$store.state.Medium.media_list.find(medium => medium.id === payload)
      } else {
        playlist = payload
      }
      if (!playlist || !playlist.PlayListItems || playlist.PlayListItems.length === 0) return ''
      const playlistFirstMediumId = JSON.parse(JSON.stringify(playlist.PlayListItems)).sort((a, b) => a.order - b.order)[0].Medium
      const playlistFirstMedium = this.$store.state.Medium.media_list.find(medium => medium.id === playlistFirstMediumId)
      if (playlistFirstMedium) {
        return playlist.PlayListItems.length === 1 ? playlistFirstMedium.name : playlistFirstMedium.name + '...'
      }
      return ''
    },
    getFullDeviceNameByDesktopId (desktopId) {
      const desktop = this.$store.state.Device.desktop_list.find(dt => dt.id === desktopId)
      if (!desktop) return this.$t('Unknown device')
      const devicename = isNaN(desktop.Device) ? desktop.Device.name : this.$store.state.Device.device_list.find(d => d.id === desktop.Device).name
      return `${devicename}${desktop.name !== 'single' ? ' ' + desktop.name : ''}`
    },
    getDeviceNameByDeviceId (deviceId) {
      const device = this.$store.state.Device.device_list.find(d => d.id === deviceId)
      if (!device) return this.$t(`Unknown device ${deviceId}`)
      return device.name
    }
  },
  computed: {
  }
}
export default textUtils



// WEBPACK FOOTER //
// ./src/components/Common/textUtils.mixin.js